import React, { useCallback, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

import AuditLogsSearch from './audit-logs-search';
import { AuditLogDateRange } from './audit-logs-date-range';
import { searchTextToActions } from './search-text-to-actions';
import AuditLogPanel from './AuditLogModal/AuditLogPanel';

import styles from './audit-logs-search-table/index.module.scss';

const WINDOW_DAYS = 90;
const SEARCH_PLACEHOLDER = 'Search Name, Email, Action, or Description...';

export default function AuditLogGlobalPage() {
  const [searchText, setSearchText] = useState('');
  const [dateRange, setDateRange] = useState(buildDateRange());

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearchText = useCallback(debounce(setSearchText, 300), []);

  const globalFilters = useMemo(
    () => ({
      name: searchText,
      email: searchText,
      description: searchText,
      actions: searchText ? searchTextToActions(searchText) : [],
      dateRange,
    }),
    [searchText, dateRange]
  );

  return (
    <div>
      <div className={styles.header}>
        <div>
          <AuditLogsSearch placeholder={SEARCH_PLACEHOLDER} onChange={debouncedSetSearchText} />
        </div>
        <div>
          <AuditLogDateRange onDatesChange={setDateRange} />
        </div>
      </div>
      <div>
        <AuditLogPanel globalFilters={globalFilters} />
      </div>
    </div>
  );
}

// Counted back from endDate, not from a second `new Date()`. endDate has already rolled to midnight
// tomorrow, so reading its getDate() off a today-based value mixes a day-of-month with a day count
// and lands in the wrong month whenever today is a month's last day.
export function buildDateRange() {
  const endDate = new Date();
  endDate.setHours(24, 0, 0, 0);
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - WINDOW_DAYS);
  return { startDate, endDate };
}
